import factors from "../data/factors.json" with { type: "json" }
import industries from "../data/industries.json" with { type: "json" }
import stations from "../data/stations.json" with { type: "json" }
import actions from "../data/actions.json" with { type: "json" }
import events from "../data/events.json" with { type: "json" }

export const DATA = { factors, industries, stations, actions, events }
